import contacts from '@/game/assets/building-ground-contacts.json';

type GroundContact = { height: number; opaqueBottom: number };
const byTextureKey: Readonly<Record<string, GroundContact>> = contacts;

/** Keep the visible ground contact at sprite.y, excluding transparent bottom padding. */
export function buildingGroundAnchorY(textureKey: string): number {
  const contact = Object.prototype.hasOwnProperty.call(byTextureKey, textureKey) ? byTextureKey[textureKey] : undefined;
  if (!contact || contact.height <= 0 || contact.opaqueBottom <= 0 || contact.opaqueBottom > contact.height) return 1;
  return contact.opaqueBottom / contact.height;
}
